/**
 * Goes Well With: Swiper carousel + AJAX add-to-cart.
 */
(function () {
  function initAddToCart(root) {
    root.querySelectorAll('.goes-well-with__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        btn.classList.add('is-loading');

        var sections = cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map(function (s) { return s.id; })
          : [];

        var body = JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname,
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: body,
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            btn.classList.remove('is-loading');
            if (response.status) {
              console.error('Add to cart error:', response.description);
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response, { open: false });
            }
            // renderContents does not run bundle sync; match bundle-constructor addToCart (getCart + syncSectionUiFromCart).
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            return fetch(root + 'cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (cartJson) {
                var payload = {
                  source: 'goes-well-with',
                  cartData: cartJson,
                  eventId: 'goes-well-with-' + Date.now(),
                };
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                  publish(PUB_SUB_EVENTS.cartUpdate, payload);
                } else {
                  document.dispatchEvent(new CustomEvent('bundle:cart-updated', { detail: payload }));
                }
              })
              .catch(function () {});
          })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            console.error('Add to cart failed:', err);
          });
      });
    });
  }

  function initGoesWith(root) {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.goes-well-with__swiper');
    var prevBtn = root.querySelector('.goes-well-with__nav--prev');
    var nextBtn = root.querySelector('.goes-well-with__nav--next');
    var slideCount = parseInt(root.getAttribute('data-slide-count'), 10) || 0;
    var bullets = Array.prototype.slice.call(root.querySelectorAll('.goes-well-with__pagination-bullet'));
    var mobileLayout = root.getAttribute('data-mobile-layout') || 'slider';
    var mqMobile = window.matchMedia('(max-width: 742px)');

    if (!swiperEl || slideCount < 1) return;

    function shouldSkipSwiper() {
      return mobileLayout === 'grid' && mqMobile.matches;
    }

    function updatePagination(swiper) {
      if (!bullets.length || !swiper) return;
      var realIdx = swiper.realIndex % slideCount;
      bullets.forEach(function (b, i) {
        b.classList.toggle('is-active', i === realIdx);
      });
    }

    function destroySwiper() {
      if (root._goesWellWithSwiper) {
        root._goesWellWithSwiper.destroy(true, true);
        root._goesWellWithSwiper = null;
      }
    }

    function mountSwiper() {
      if (root._goesWellWithSwiper) return;
      var swiper = new Swiper(swiperEl, {
        loop: slideCount > 4,
        slidesPerView: 1.2,
        spaceBetween: 16,
        speed: 400,
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          743: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
        on: {
          afterInit: function (sw) {
            updatePagination(sw);
          },
          slideChangeTransitionEnd: function (sw) {
            updatePagination(sw);
          },
        },
      });
      root._goesWellWithSwiper = swiper;
    }

    function syncSwiperMode() {
      if (shouldSkipSwiper()) {
        destroySwiper();
      } else {
        mountSwiper();
      }
    }

    syncSwiperMode();

    var mqHandler = function () {
      syncSwiperMode();
    };
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', mqHandler);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(mqHandler);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-goes-well-with]').forEach(function (root) {
      initGoesWith(root);
      initAddToCart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
